<template>
  <div class="interaction-buttons">
    <component
      v-for="interactionButton in interactionButtons"
      :key="interactionButton.key"
      :is="interactionButton.componentName"
    />
  </div>
</template>

<script>
import InteractionMixin from '@/mixins/store/interaction'
import ElevationProfilButton from './profil.vue'

export default {
  name: 'InteractionPanel',
  mixins: [
    InteractionMixin
  ],
  components: {
    ElevationProfilButton
  }
}
</script>

<style lang="scss" scoped>
.interaction-container {
  display: flex;
  flex-direction: column;

  .interaction-button {
    width: 34px;
    height: 34px;
    padding: 5px;
    cursor: pointer;
    margin-bottom: 5px;
    background-color: #ffffff;

    &.dense {
      margin-bottom: 0px;
      border-bottom: 1px solid grey;
    }
  }

}
</style>
